import CampaignIcon from '@mui/icons-material/Campaign'
import DashboardIcon from '@mui/icons-material/Dashboard'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import QuizIcon from '@mui/icons-material/Quiz'
import ReceiptIcon from '@mui/icons-material/Receipt'
import SettingsIcon from '@mui/icons-material/Settings'
import { routeBackOfficeAllEntityAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeAllEntityAdminCommon'
import { routeBackOfficeOrdersAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeOrdersAdminCommon.ts'
import { routeBackOfficeStudentAdminCommon } from '@/lib/routes/backoffice/common/routeBackOfficeStudentAdminCommon'
import routeDocumentTemplateRoutes from "@/lib/routes/backoffice/common/routeDocumentTemplateRoutes";
import { MENU_GROUPS } from '@/lib/routes/menuGroups'
import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getBackOfficeInsightAdmin = [
  {
    route: 'Dashboard',
    text: 'Tableau de bord',
    t: 'routes.backoffice.insight.dashboard',
    icon: DashboardIcon,
    href: '/backoffice/insight/dashboard',
    menuHeader: true,
    position: 10,
  },
  {
    route: 'SurveyList',
    text: 'Enquêtes',
    icon: QuizIcon,
    href: '/backoffice/insight/survey',
    menuHeader: true,
    // Juste sous « Programmes » (40) : les enquêtes composent les programmes.
    position: 45,
  },
  {
    route: 'SurveyAdd',
    text: 'Ajouter  un questionnaire',
    href: '/backoffice/insight/survey/add-survey',
  },
  {
    route: 'ProgramAdd',
    text: 'Ajouter une programme',
    href: '/backoffice/insight/program/add-program',
  },
  {
    route: 'AdminInsightGestionFinance',
    text: 'Gestion financière',
    icon: ReceiptIcon,
    href: '/backoffice/insight/finance',
    menuHeader: true,
    position: 50,
  },
  {
    route: 'AdminInsightDeclarations',
    // Point d'entree unique des declarations (EPS et Transparence Sante, 10/10/2026). Ouverte
    // aussi au profil « Saisie des declarations » (onglet EPS, <= 2 000 € TTC).
    text: 'Déclarations',
    t: 'routes.backoffice.insight.declarations',
    icon: FactCheckIcon,
    href: '/backoffice/insight/declarations',
    menuHeader: true,
    position: 55,
  },
  {
    route: 'TransparencySante',
    text: 'Transparence Santé',
    icon: FactCheckIcon,
    // Hors menu : l'ancienne adresse redirige vers l'onglet Transparence Santé de Déclarations.
    href: '/backoffice/insight/transparency-sante',
    menuHeader: false,
    position: 56,
  },
  {
    route: 'ProductAdd',
    text: 'Ajouter un produit',
    href: '/backoffice/insight/product/add-product',
  },
  {
    route: 'SurveyEdit',
    text: 'Editer  un questionnaire',
    href: '/backoffice/insight/survey/edit-survey/[surveyId]',
  },
  {
    route: 'SurveyEditInternal',
    text: 'Editer  un questionnaire interne',
    href: '/backoffice/insight/newsurvey/edit-survey/[surveyId]',
  },
  {
    route: 'SurveyV99Builder',
    text: 'Editer un questionnaire V99',
    href: '/backoffice/insight/survey/v99/[surveyId]',
  },
  {
    route: 'SurveyExport',
    text: 'Export des questionnaires',
    href: '/backoffice/insight/survey/export-survey',
  },
  {
    route: 'ProgramInsightList',
    text: 'Programmes',
    icon: CampaignIcon,
    href: '/backoffice/insight/program',
    menuHeader: true,
    position: 40,
  },
  {
    route: 'ProgramEdit',
    text: 'Editer une programme',
    href: '/backoffice/insight/program/edit-program/[programId]',
  },
  {
    route: 'ProgramStat',
    text: 'Statistiques',
    href: '/backoffice/insight/program/stat-program',
  },

  {
    route: 'ProductEdit',
    text: 'Editer un produit',
    href: '/backoffice/insight/product/edit-product/[productId]',
  },
  {
    route: 'Settings',
    menuGroup: MENU_GROUPS.TOOLS,
    text: 'Paramétrage',
    icon: SettingsIcon,
    href: '/backoffice/common/settings',
    menuHeader: true,
    position: 310,
  },
  {
    route: 'AddDocument',
    text: 'Ajouter un document',
    href: '/backoffice/common/document/add-document',
    menuHeader: false,
  },
  {
    route: 'EditDocument',
    text: 'Editer un document',
    href: '/backoffice/common/document/edit-document/[documentId]',
    menuHeader: false,
  },
  {
    route: 'FilterFinance',
    text: 'Export des factures pharmaciens',
    href: '/backoffice/[entity]/finance/export-filter',
  },
  {
    route: 'HistoFinancial',
    text: 'Centre des exports',
    href: '/backoffice/[entity]/finance/export-history',
  },
  ...routeBackOfficeAllEntityAdminCommon,
  ...routeBackOfficeStudentAdminCommon,
  ...routeBackOfficeOrdersAdminCommon,
  ...routeDocumentTemplateRoutes,
].map(route => ({
  ...route,
  entity: [EntityList.PHARMEDINSIGHT],
  // Seule la page Declarations s'ouvre au profil « Saisie des declarations » ; toutes les autres
  // routes Insight (communes comprises) restent aux admins Insight, comme avant.
  roles:
    route.route === 'AdminInsightDeclarations'
      ? [CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN, CONSTANTS.ROLE_DECLARATION_ENTRY]
      : [CONSTANTS.ROLE_DYNAMIC_ROUTE_INSIGHT_ADMIN],
}))

export default getBackOfficeInsightAdmin
